export const defaultUserState = {
	UserList: [],
	userListLoaded: false,
	Total: 0,
	currentUserTax: null
};

export default {
	...defaultUserState
};
